// import Accordion from '../../plugins/accordion.js';
// const elements = document.querySelectorAll(".js-accordion");
// for (const element of elements) {
//   let accordion2 = new Accordion(element, {
//     defaultOpenPanels: [1],
//     multipleOpen: false,
//     onOpen: hoge,
//     onClose: fuga
//   });
// }




// let accordion = new Accordion(".js-accordion2", {
//   defaultOpenPanels: [0],
//   onOpen: hoge,
//   onClose: fuga
// });

// function hoge(trigger, panel){
//   panel.style.color = "#f00"
// }
// function fuga(trigger, panel){
//   console.log("aaaaa")
//   console.log(panel)
// }

// accordion.destroy()
// accordion.init()
